module.exports = __webpack_public_path__ + "static/media/mainImage.a151ced1.jpeg";